import type { ContactAddress } from "./types";

export function formatAddress(
  address: ContactAddress,
  apartment: string | null,
): string {
  const streetAndHouseNumer = [address.street, address.houseNumber]
    .filter((part) => part != null && part !== "")
    .join(" ");

  if (apartment != null && apartment !== "") {
    return [streetAndHouseNumer, apartment].join(", ");
  }

  return streetAndHouseNumer;
}
